import Container from "./container";
import footerLogo from "../../assets/images/commalax-landing/logo-2.png";
import { ImFacebook2 } from "react-icons/im";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";

const Footer = () => {
  const icons = [
    {
      icon: ImFacebook2,
      link: "#",
    },
    {
      icon: FaInstagramSquare,
      link: "#",
    },
    {
      icon: FaTiktok,
      link: "#",
    },
    {
      icon: AiOutlineMail,
      link: "#",
    },
  ];
  return (
    <Container>
      <footer className="space-y-5 pb-10 ">
        <div className="flex items-center justify-center">
          <img src={footerLogo} className="w-40" alt="commalax footer logo" />
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-10">
          <div className="space-y-3 flex-1">
            <p>
              <b>'Commalax'</b> came from two words: <b>'comma'</b>, meaning
              break or pause, and <b>'lax'</b>, the last three letters of relax.
              Thus, Commalax implies taking a restful break while shopping for
              superior skin care and cosmetics.
            </p>
            <p>
              Our mission is to make quality Korean brands available, accessible
              and affordable to nationwide.
            </p>
          </div>
          <div className="flex-1 flex justify-start md:justify-end">
            <div className="space-y-5">
              <p>FOLLOW US ON</p>
              <div className="flex items-center gap-5">
                {icons.map((icon, i) => {
                  const Icon = icon.icon;
                  return (
                    <a href={icon.link} key={i}>
                      <Icon size={25} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Container>
  );
};
export default Footer;
